import React, { useEffect, useState } from "react";
import { Button, Input, Table } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { BiSearchAlt2 } from "react-icons/bi";
import { RiFileList3Line } from "react-icons/ri";
import { GrAddCircle } from "react-icons/gr";
import "../admin/style.css";
import { toast } from "react-toastify";
import { GiArrowWings } from "react-icons/gi";
import ModalConfirm from "../../components/admin/ModalConfirm";
import { getData, putData } from "../../api/method";
import Pagination from "../../components/pagination";

function Orders(args) {
  const [openShip, setOpenShip] = useState(false);

  const toggleShip = () => setOpenShip(!openShip);

  const closeBtnShip = (
    <button className="close" onClick={toggleShip}>
      &times;
    </button>
  );

  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const getOrder = async () => {
    try {
      const result = await getData("/api/Order");
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrder();
  }, [data]);

  const [dataEdit, setDataEdit] = useState([]);

  const getOrderById = async (id) => {
    try {
      const result = await getData(`/api/Order/${id}`);
      setDataEdit(result.data);
      setOpenShip(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitShip = async (id) => {
    const editData = new FormData();

    editData.append("id", id);
    editData.append("status", 1);
    editData.append("address", dataEdit.address);
    editData.append("ward", dataEdit.ward);
    editData.append("district", dataEdit.district);
    editData.append("city", dataEdit.city);
    editData.append("userId", dataEdit.userId);

    try {
      const res = await putData(`/api/Order/${id}`, editData);
      if (res.status === 200) {
        toast.success("Success!");
        setOpenShip(false);
      }
    } catch (err) {
      console.log(err);
      setOpenShip(false);
      toast.error("Fail!");
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(12);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <div className="d-flex align-items-center line_border--admin">
        <BiSearchAlt2 className="t-grey ms-2" />

        <Input
          className="border-0"
          placeholder="Enter you keyword..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="pt-4">
        <div className="d-flex justify-content-between pb-4">
          <Button className="btn_add btn_add--cus fs-20 d-flex align-items-center">
            <GrAddCircle className="me-2" />
            Add
          </Button>
        </div>

        <Table className="table_admin">
          <thead>
            <tr className="fw-bold">
              <th className="table_o_stt">#</th>
              <th className="table_o_customer">Customer</th>
              <th className="table_o_date">Date</th>
              <th className="table_o_price">Price</th>
              <th className="table_o_address">Address</th>
              <th className="table_o_detail">Detail</th>
              <th className="table_o_status">Order status</th>
              <th className="table_o_ship"></th>
            </tr>
          </thead>
          <tbody>
            {currentData
              ?.sort((a, b) => new Date(b.date) - new Date(a.date))
              .filter((item) => {
                if (search === "") {
                  return item;
                } else if (
                  item.user.firstname
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                  item.user.lastname
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                  item.address.toLowerCase().includes(search.toLowerCase()) ||
                  item.ward.toLowerCase().includes(search.toLowerCase()) ||
                  item.district.toLowerCase().includes(search.toLowerCase()) ||
                  item.city.toLowerCase().includes(search.toLowerCase()) ||
                  item.date.toLowerCase().includes(search.toLowerCase())
                ) {
                  return item;
                }
              })
              .map((item, index) => (
                <tr key={index}>
                  <td className="table_o_stt">{index}</td>
                  <td className="table_o_customer">
                    {item.user.lastname} {item.user.firstname}
                  </td>
                  <td className="table_o_date">{item.date.slice(0, 10)}</td>
                  <td className="table_o_price">
                    {item.totalPrice.toLocaleString("vi")}&#273;
                  </td>
                  <td className="table_o_address">
                    {item.address}, {item.ward}, {item.district}, {item.city}
                  </td>
                  <td
                    className="table_o_detail cursor_pointer"
                    onClick={() => navigate(`/admin/order-detail/${item.id}`)}
                  >
                    <RiFileList3Line className="fs-4" />
                  </td>
                  <td className="table_o_status">
                    {item.status === 0 ? (
                      "Waitting"
                    ) : (
                      <>
                        {item.status === 1 ? (
                          "Delivery"
                        ) : (
                          <>
                            {item.status === 2 ? (
                              "Received"
                            ) : (
                              <>{item.status === 3 ? "Cancelled" : ""}</>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </td>
                  {item.status === 0 ? (
                    <td
                      className="table_o_ship cursor_pointer fs-5"
                      onClick={() => getOrderById(item.id)}
                    >
                      <GiArrowWings />
                    </td>
                  ) : (
                    <></>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>

        <Pagination
          paginate={paginate}
          postsPerPage={dataPerPage}
          totalPosts={data.length}
        />
      </div>

      <ModalConfirm
        title="Delivery"
        text="Delivery confirmation?"
        toggle={toggleShip}
        close={closeBtnShip}
        isOpen={openShip}
        onClick={() => handleSubmitShip(dataEdit.id)}
      />
    </div>
  );
}

export default Orders;
